import { Dayjs } from 'dayjs';
import { isNumber } from 'lodash-es';
import { getWeekOfMonth, startOfMonth } from 'date-fns';
import dayjs from '../dayjs/dayjs';
import { getShiftDayValue } from './getShiftDayValue';
import { CreateScheduleRepeat } from '../../models/dto';
import { DaysOfWeekEnum } from '../../enums';
import { isDayOfLastWeekOfMonth } from './isDayOfLastWeekOfMonth';
import { getLocalTimeZone } from '../time-zones.utils';

export const shiftScheduleRepeat = (
  date: Date | Dayjs,
  scheduleRepeat: CreateScheduleRepeat,
  shiftBack = false,
	timezone = getLocalTimeZone(),
): CreateScheduleRepeat => {
	// Parse the date in the timezone and apply UTC without changing the time
  const time = dayjs(dayjs(date).tz(timezone).utcOffset(0, true).format()).utc();
  const utcTime = dayjs(date).utc();

  if (time.isSame(utcTime, 'date')) {
    return scheduleRepeat;
  }

  const shiftValue = getShiftDayValue(date, shiftBack, timezone);

  const newScheduleRepeat = { ...scheduleRepeat } as CreateScheduleRepeat;

  // shift day of month
  newScheduleRepeat.dayOfMonth = isNumber(scheduleRepeat?.dayOfMonth)
    ? time
        .set('date', scheduleRepeat.dayOfMonth)
        .add(shiftValue, 'day')
        .get('date')
    : scheduleRepeat?.dayOfMonth;

  // shift week days
  const daysOfWeekArray = Object.values(DaysOfWeekEnum);

  newScheduleRepeat.dayOfWeekIds = scheduleRepeat.dayOfWeekIds?.map((dayOfWeekId) => {
		const currentDayOfWeekIndex = daysOfWeekArray.findIndex(value => value === dayOfWeekId);

		const newIndex = currentDayOfWeekIndex + shiftValue;

		if (newIndex < 0) {
			return daysOfWeekArray[daysOfWeekArray.length - 1];
		}

		if (newIndex >= daysOfWeekArray.length) {
			return daysOfWeekArray[0];
		}

		return daysOfWeekArray[newIndex];
	});


	// shift week of month
	if (isNumber(scheduleRepeat?.weekOfMonth)) {
		const date = shiftBack ? utcTime.toDate() : time.toDate();
		scheduleRepeat.weekOfMonth = isDayOfLastWeekOfMonth(date) ? -1 : getWeekOfMonth(date, {
			weekStartsOn: startOfMonth(date).getDay() as 0 | 1 | 2 | 3 | 5 | 6
		});
	}

  return newScheduleRepeat;
};
